import React from "react";
import SEO from "../components/SEO";

const Terms = () => {
  return (
    <>
      <SEO
        title='Terms'
        description='Shirts Patches'
        keywords='Shirts Patches'
      />
      <div className="relative bg-gradient-to-br from-green-50 via-white to-green-100 min-h-screen">
        {/* Decorative Blobs */}
        <div className="absolute top-0 left-0 w-72 h-72 bg-[#369a74]/20 rounded-full blur-3xl -z-10" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#369a74]/20 rounded-full blur-3xl -z-10" />

        <div className="container mx-auto px-4 py-20 max-w-6xl">
          {/* Header */}
          <div className="text-center mb-20">
            <span className="inline-block mb-4 px-5 py-2 rounded-full bg-[#369a74]/20 text-[#369a74] text-md font-semibold">
              Legal Information
            </span>
            <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 tracking-tight">
              Terms of Service
            </h1>
            <p className="mt-6 text-gray-700 max-w-3xl mx-auto text-lg leading-relaxed">
              Please read these terms carefully before using the Personalised
              Patches for Hats website or placing an order.
            </p>
          </div>

          {/* Main Card */}
          <div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-gray-200 p-8 md:p-14 space-y-14">

            {/* Section Wrapper */}
            {[
              {
                title: "User Agreement",
                content: (
                  <>
                    <p>
                      This website is operated by{" "}
                      <strong>Personalised Patches for Hats</strong>. By accessing
                      our website or placing an order, you agree to be legally
                      bound by these Terms of Service and all related policies.
                    </p>
                    <p className="mt-4">
                      Continued use of the website constitutes acceptance of any
                      updates or modifications made to these terms.
                    </p>
                  </>
                ),
              },
              {
                title: "Design Responsibility",
                content: (
                  <p>
                    You are fully responsible for the accuracy, legality, and
                    ownership of any design you submit. You agree to indemnify
                    Personalised Patches for Hats from any claims resulting from
                    submitted artwork.
                  </p>
                ),
              },
              {
                title: "Intellectual Property Rights",
                content: (
                  <>
                    <p>
                      You must own or have permission to use all trademarks,
                      logos, or copyrighted material included in your designs.
                    </p>
                    <p className="mt-4">
                      We reserve the right to refuse or cancel orders that violate
                      intellectual property laws or contain inappropriate content.
                    </p>
                  </>
                ),
              },
              {
                title: "Intellectual Property Claims",
                content: (
                  <>
                    <p>
                      If you believe your intellectual property rights have been
                      violated, contact our legal team with proper documentation.
                    </p>
                    <div className="mt-4 text-sm bg-[#369a74]/10 rounded-xl p-4">
                      <p className="font-semibold text-[#369a74]">
                        Personalised Patches for Hats – Legal Team
                      </p>
                      <p>Email: support@personalisedpatchesforhats.com</p>
                    </div>
                  </>
                ),
              },
              {
                title: "Privacy Policy",
                content: (
                  <p>
                    Your privacy matters to us. Our Privacy Policy explains how
                    we collect, use, and protect your personal information.
                  </p>
                ),
              },
              {
                title: "Limitation of Liability",
                content: (
                  <>
                    <p>
                      All services are provided “as is” without warranties of any
                      kind. We are not liable for technical errors or service
                      interruptions.
                    </p>
                    <p className="mt-4">
                      You agree to indemnify our company against any claims or
                      damages arising from misuse of our services.
                    </p>
                  </>
                ),
              },
              {
                title: "Health & Safety Disclaimer",
                content: (
                  <p>
                    We are not responsible for injuries or damages caused by
                    misuse of patches or heat-application equipment.
                  </p>
                ),
              },
              {
                title: "Returns, Cancellations & Payments",
                content: (
                  <p>
                    Please review our Refund Policy and Shipping Policy pages for
                    complete details regarding payments and order issues.
                  </p>
                ),
              },
              {
                title: "Governing Law & Disputes",
                content: (
                  <p>
                    These Terms are governed by applicable local laws. Disputes
                    shall be resolved through binding arbitration where permitted.
                  </p>
                ),
              },
            ].map((section, index) => (
              <section
                key={index}
                className="relative pl-6 group hover:bg-[#369a74]/10 transition-all duration-300 rounded-xl p-4"
              >
                <div className="absolute left-0 top-2 h-full w-1 rounded-full bg-gradient-to-b from-[#369a74] to-[#32c499] group-hover:scale-110 transition-transform" />
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  {section.title}
                </h2>
                <div className="text-gray-700 leading-relaxed text-base">
                  {section.content}
                </div>
              </section>
            ))}

            {/* Contact */}
            <section className="border-t pt-10 text-center">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Contact Us
              </h2>
              <p className="text-gray-700 mb-4">
                If you have any questions regarding these Terms of Service:
              </p>
              <p className="font-semibold text-[#369a74]">
                Personalised Patches for Hats
              </p>
              <p className="text-gray-700">
                Email: support@personalisedpatchesforhats.com
              </p>
            </section>

            {/* Footer */}
            <p className="text-sm text-gray-500 text-center pt-8 border-t">
              Last updated on 07/08/2025
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Terms;
